import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { EuCountries } from 'todistukset-common/src/vtj/EuCountries.enum'
import { CountryKoodistoCode } from 'todistukset-common/src/vtj/vtj-koodisto.util'
import { PlaceOfMarriage } from 'todistukset-common/src/vtj/types/place-of-marriage'
import { TodistusAsiointikieli } from 'todistukset-common/src/vtj/types/todistus-person.type'

export const getNativeLanguagesByCountryCode = (
  countryCode: CountryKoodistoCode | null
): LanguageCode[] => {
  switch (countryCode) {
    case EuCountries.AUSTRIA:
      return [LanguageCode.DE]
    case EuCountries.BELGIUM:
      return [LanguageCode.NL, LanguageCode.FR, LanguageCode.DE]
    case EuCountries.BULGARIA:
      return [LanguageCode.BG]
    case EuCountries.CROATIA:
      return [LanguageCode.HR]
    case EuCountries.CYPRUS:
      return [LanguageCode.EL]
    case EuCountries.CZECH_REPUBLIC:
      return [LanguageCode.CS]
    case EuCountries.DENMARK:
      return [LanguageCode.DA]
    case EuCountries.ESTONIA:
      return [LanguageCode.ET]
    case EuCountries.FINLAND:
      return [LanguageCode.FI, LanguageCode.SV]
    case EuCountries.FRANCE:
      return [LanguageCode.FR]
    case EuCountries.GERMANY:
      return [LanguageCode.DE]
    case EuCountries.GREECE:
      return [LanguageCode.EL]
    case EuCountries.HUNGARY:
      return [LanguageCode.HU]
    case EuCountries.IRELAND:
      return [LanguageCode.EN, LanguageCode.GA]
    case EuCountries.ITALY:
      return [LanguageCode.IT]
    case EuCountries.LATVIA:
      return [LanguageCode.LV]
    case EuCountries.LITHUANIA:
      return [LanguageCode.LT]
    case EuCountries.LUXEMBOURG:
      return [LanguageCode.FR]
    case EuCountries.MALTA:
      return [LanguageCode.MT, LanguageCode.EN]
    case EuCountries.NETHERLANDS:
      return [LanguageCode.NL]
    case EuCountries.POLAND:
      return [LanguageCode.PL]
    case EuCountries.PORTUGAL:
      return [LanguageCode.PT]
    case EuCountries.ROMANIA:
      return [LanguageCode.RO]
    case EuCountries.SLOVAKIA:
      return [LanguageCode.SK]
    case EuCountries.SLOVENIA:
      return [LanguageCode.SL]
    case EuCountries.SPAIN:
      return [LanguageCode.ES]
    case EuCountries.SWEDEN:
      return [LanguageCode.SV]
    case EuCountries.UNITED_KINGDOM:
      return [LanguageCode.EN]
    default:
      return []
  }
}

export const getAvailableTodistusLanguages = (
  usageRegion: CountryKoodistoCode | null
): LanguageCode[] => {
  if (usageRegion === EuCountries.SWEDEN) {
    return [LanguageCode.SV, LanguageCode.EN]
  }
  return [LanguageCode.FI, LanguageCode.SV, LanguageCode.EN]
}

export const availableVtjOteTodistusLanguages = [
  LanguageCode.FI,
  LanguageCode.SV,
  LanguageCode.EN,
] as const

export const availableAETTodistusLanguages = [
  LanguageCode.FI,
  LanguageCode.SV,
] as const

export const availableUAETTodistusLanguages = [
  LanguageCode.FI,
  LanguageCode.SV,
  LanguageCode.EN,
] as const

export const availableElomakeTodistusLanguages = [
  LanguageCode.FI,
  LanguageCode.SV,
  LanguageCode.EN,
  LanguageCode.ES,
  LanguageCode.IT,
  LanguageCode.FR,
  LanguageCode.DE,
] as const

export const availableTranslations = [
  LanguageCode.BG,
  LanguageCode.CS,
  LanguageCode.DA,
  LanguageCode.DE,
  LanguageCode.EL,
  LanguageCode.EN,
  LanguageCode.ES,
  LanguageCode.ET,
  LanguageCode.FR,
  LanguageCode.GA,
  LanguageCode.HR,
  LanguageCode.HU,
  LanguageCode.IT,
  LanguageCode.LT,
  LanguageCode.LV,
  LanguageCode.MT,
  LanguageCode.NL,
  LanguageCode.PL,
  LanguageCode.PT,
  LanguageCode.RO,
  LanguageCode.SK,
  LanguageCode.SL,
  LanguageCode.SV,
] as const

export const expectedAetTodistusLanguage = {
  [PlaceOfMarriage.FINLAND]: [LanguageCode.FI, LanguageCode.SV],
  [PlaceOfMarriage.NORDICS]: [LanguageCode.SV],
}

export const availableTodistusAsiointikielet = [
  LanguageCode.FI,
  LanguageCode.SV,
  LanguageCode.EN,
] as const satisfies TodistusAsiointikieli[]

export const langIsTodistusasiointikieli = (
  lang: LanguageCode
): lang is TodistusAsiointikieli =>
  availableTodistusAsiointikielet.includes(lang as TodistusAsiointikieli)

export type TodistusVtjOteKieli =
  (typeof availableVtjOteTodistusLanguages)[number]

export const langIsVtjOteKieli = (
  lang: LanguageCode
): lang is TodistusVtjOteKieli =>
  availableVtjOteTodistusLanguages.includes(lang as TodistusVtjOteKieli)
